import React from 'react';

import styled from 'styled-components';

import { COLORS } from '../../../utils/theme/colors';
import Polygon from '../../atoms/icons/Polygon';

export const HeaderIcon = () => {


  return (
    <Div className="header_icon_gabrr">
      <Polygon className="polygon" />
    </Div>
  ); 
};

const Div = styled.div`
    transition: 200ms ease-in-out;
    top: 50%;
    display: flex;
    transform: rotate(-180deg) translateY(50%);
    transform-origin: center;
    position: absolute;
    right: 10px;

    &.active {
        transform: rotate(0deg) translateY(-50%);
        transform-origin: center;
        fill: ${COLORS.primary};
    }

    .polygon path {
        fill: ${COLORS.lightDarkText}
    }
    &:hover path {
        fill: ${COLORS.primary}
    }

`;